"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("./styles");
/**
 * Componente de Tag, para exibição de labels na tela.
 *
 * @returns JSX Component
 */
var TagStatus = function (_a) {
    var status = _a.status, width = _a.width, paddingY = _a.paddingY, paddingX = _a.paddingX, fontSize = _a.fontSize, color = _a.color, background = _a.background, _b = _a.customPadding, customPadding = _b === void 0 ? false : _b, styleFont = _a.styleFont;
    return (jsx_runtime_1.jsx(styles_1.Tag, __assign({ status: status, width: width, fontSize: fontSize, paddingY: paddingY, paddingX: paddingX, customPadding: customPadding, styleFont: styleFont, color: color, background: background }, { children: status }), void 0));
};
exports.default = TagStatus;
//# sourceMappingURL=index.js.map